import { FormattedMessage } from 'react-intl';
import { Alert } from '@mui/material';
import * as React from 'react';
import type { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat';

interface InfoAlertProps {
  messageId: string;
  values?: Record<string, React.ReactNode | PrimitiveType | FormatXMLElementFn<React.ReactNode>>;
}

export function InfoAlert({ messageId, values = undefined }: InfoAlertProps) {
  return (
    <Alert className="mb-4" severity="info">
      <div className="whitespace-pre-wrap">
        <FormattedMessage id={messageId} values={values} />
      </div>
    </Alert>
  );
}
